module.exports = __webpack_public_path__ + "img/four.52f38bda.png";